export default "__VITE_ASSET__CwlUDgaH__"